var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headTip'),_c('userHead'),_c('div',{staticClass:"userInfo"},[_c('div',{staticClass:"userInfo_left"},[_c('userLeft')],1),_c('div',{staticClass:"userInfo_right"},[_c('router-view')],1)]),_c('footerTip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }